import { useBoardSelector } from '../../index';
import { shouldShowUnassignedFilterCTASelector } from '../../selectors/unassigned-filter-cta/unassigned-filter-cta-selector';

export function useShouldShowUnassignedFilterCTA(): boolean {
	return useBoardSelector(shouldShowUnassignedFilterCTASelector);
}
